import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=18525504"
import script from "./file-list.vue?vue&type=script&lang=ts"
export * from "./file-list.vue?vue&type=script&lang=ts"
import style0 from "./file-list.vue?vue&type=style&index=0&id=18525504&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports